import { useEffect, useState } from "react";
import {
  IconArrowUpRight as ArrowUpRight,
  IconMoon as Moon,
  IconSun as Sun,
} from "@tabler/icons-react";
import { LOGO_URL } from "../../constants/assets";

export function Header({ theme, setTheme, lang, setLang, t, isHome = true }) {
  const [scrolled, setScrolled] = useState(false);
  const sectionHref = (hash) => (isHome ? hash : `/${hash}`);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[hsl(var(--surface)/0.78)] border-b border-[hsl(var(--border))]"
          : "bg-transparent"
      }`}
    >
      <div className="container-x flex h-[68px] items-center justify-between">
        <a href={sectionHref("#top")} className="flex items-center gap-2.5" data-testid="logo-link" aria-label="Innospeq Home">
          <img
            src={LOGO_URL}
            alt="Innospeq"
            className="h-7 md:h-8 w-auto select-none"
            style={{ filter: "var(--logo-filter, none)" }}
            draggable="false"
          />
        </a>

        {/* <nav className="hidden items-center gap-8 md:flex" data-testid="primary-nav">
          <a href={sectionHref("#problem")} className="nav-link text-sm font-medium text-muted-foreground hover:text-[hsl(var(--foreground))]">
            {t.nav.problem}
          </a>
          <a href={sectionHref("#solution")} className="nav-link text-sm font-medium text-muted-foreground hover:text-[hsl(var(--foreground))]">
            {t.nav.solution}
          </a>
          <a href={sectionHref("#advantages")} className="nav-link text-sm font-medium text-muted-foreground hover:text-[hsl(var(--foreground))]">
            {t.nav.advantages}
          </a>
          <a href={sectionHref("#usecases")} className="nav-link text-sm font-medium text-muted-foreground hover:text-[hsl(var(--foreground))]">
            {t.nav.usecases}
          </a>
        </nav> */}

        <div className="flex items-center gap-2">
          <div className="toggle-pill" data-testid="lang-toggle">
            <button
              onClick={() => setLang("de")}
              className={lang === "de" ? "active" : ""}
              data-testid="lang-de"
              aria-label="Deutsch"
            >
              DE
            </button>
            <button
              onClick={() => setLang("en")}
              className={lang === "en" ? "active" : ""}
              data-testid="lang-en"
              aria-label="English"
            >
              EN
            </button>
          </div>

          <button
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            data-testid="theme-toggle"
            aria-label="Toggle theme"
            className="grid h-9 w-9 place-items-center rounded-full border border-[hsl(var(--border))] bg-[hsl(var(--surface)/0.6)] text-[hsl(var(--foreground))] transition-all hover:border-[hsl(var(--brand))] hover:text-[hsl(var(--brand))]"
          >
            {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </button>

          <a
            href={sectionHref("#contact")}
            data-testid="header-cta"
            className="btn-pill btn-primary hidden md:inline-flex text-sm py-2.5 px-5"
          >
            {t.nav.contact}
          </a>

          <a
            href="https://app.innospeq.com"
            target="_blank"
            rel="noreferrer"
            data-testid="header-app-link"
            className="btn-pill btn-ghost hidden md:inline-flex text-sm py-2.5 px-5"
          >
            {t.nav.app}
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </header>
  );
}
